import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../../../auth/useAuth';
import { knowledgeService } from '../../../services/KnowledgeService';
import { knowledgeQueryKeys } from '../knowledgeQueryKeys';

export function useKnowledgeMembersQuery(databaseId: string | undefined) {
  const { user } = useAuth();
  const isEnabled = Boolean(user) && Boolean(databaseId);

  return useQuery({
    queryKey: knowledgeQueryKeys.members(databaseId ?? ''),
    enabled: isEnabled,
    queryFn: () => knowledgeService.listMembers(databaseId!),
  });
}
